//import _ from 'lodash'

const addFilter = 'ADD_FILTER';
const removeFilter = 'REMOVE_FILTER'
const removeAll = 'REMOVE_ALL'
const addSearchQuery = 'ADD_SEARCH'
const removeSearchQuery = 'REMOVE_SEARCH'
const tagUpdate = 'TAG_UPDATE'
const currentOpen = 'CURRENT_OPEN'
const tagAdd = 'TAG_ADD'

export const searchBarActions = {
    addFilter,
    removeFilter,
    removeAll,
    addSearchQuery,
    removeSearchQuery,
    currentOpen,
    tagUpdate,
    tagAdd

};

export const actionCreators = {
    addSearchFilter: (tag)=>(dispath,getState) => {
        dispath({type:addFilter,payload:tag})
    },
    removeSearchFilter: (tag)=> (dispath,getState)=>{
        dispath({type:removeFilter,payload:tag})
    },
    addSearch: (query)=>(dispatch,getState)=>{
        dispatch({type:addSearchQuery,payload:query})
    },
    removeSearch: ()=>(dispatch,getState)=>{
        if(!getState().filterData.searchQuery){
            return;
        }
        dispatch({type:removeSearchQuery,payload:''})
    },
    removeAllFilters:()=>(dispatch,getState)=>{
        dispatch({type:removeAll,payload:{filters:[],searchQuery:''}})
    },
    setCurrentOpen:(id)=>(dispatch,getState)=>{
        dispatch({type:currentOpen,payload:id})
    },
    
}